import {
  AutocompleteInput,
  Create,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  type RaRecord,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { RazaBackedEventFormFields } from "@/components/raza/RazaBackedEventFormFields";
import {
  buildOhbatEventCreatePayload,
  buildRazaBackedEventCreatePayload,
} from "@/utils/raza-request-event-payload";
import { RazaEventOhbatFormFields } from "./RazaEventOhbatFormFields";

const kindChoices = [
  { id: "raza", name: "Raza-backed" },
  { id: "ohbat", name: "Ohbat" },
];

function RazaEventsCreateFormFields() {
  const kind = useWatch({ name: "kind" }) ?? "raza";

  return (
    <>
      <SelectInput source="kind" label="Kind" choices={kindChoices} fullWidth isRequired />
      {kind === "ohbat" ? (
        <RazaEventOhbatFormFields />
      ) : (
        <>
          <ReferenceInput source="razaRequestId" reference="razaRequests" perPage={100}>
            <AutocompleteInput
              label="Raza request"
              optionText={(r: RaRecord) =>
                [r.name, r.itsNo].filter(Boolean).join(" — ") || String(r.id)
              }
              fullWidth
              isRequired
              helperText="Required for raza-backed events"
            />
          </ReferenceInput>
          <RazaBackedEventFormFields />
        </>
      )}
    </>
  );
}

function transformCreate(data: Record<string, unknown>): Record<string, unknown> {
  if (data.kind === "ohbat") {
    return buildOhbatEventCreatePayload(data);
  }
  const razaRequestId = typeof data.razaRequestId === "string" ? data.razaRequestId.trim() : "";
  return buildRazaBackedEventCreatePayload(data, razaRequestId);
}

const RazaEventsCreate = () => (
  <Create redirect="list" transform={transformCreate}>
    <SimpleForm
      warnWhenUnsavedChanges
      sx={{ maxWidth: 1120 }}
      defaultValues={{
        kind: "raza",
        startTime: "09:00",
        needSadaratMale: true,
        needSadaratFemale: false,
      }}
    >
      <RazaEventsCreateFormFields />
    </SimpleForm>
  </Create>
);

export default RazaEventsCreate;
